import { handleError } from "@network/handle-errors";
import { http } from "@network/http";
import setLanguage from "next-translate/setLanguage";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "noval";
import { loadIntercomScript } from "@components/Intercom/IntercomBot";
import { useCallback, useEffect } from "react";

export const useIntercomToggle = (lang) => {
  const [loadingIntercom, supportOpen] = useSelector(
    ["loadingIntercom", "supportOpen"],
    [false, false]
  );

  const { dispatch } = useDispatch();
  const { pathname } = useRouter();

  const intercom_toggler = useCallback(() => {
    if (!loadingIntercom) {
      if (!window.Intercom) {
        dispatch({ loadingIntercom: true });
        loadIntercomScript(pathname, lang)
          .then(() => {
            setTimeout(() => {
              dispatch({ loadingIntercom: false });
            }, 1000);
            dispatch({ supportOpen: !supportOpen });
          })
          .catch(() => {
            dispatch({ loadingIntercom: false });
          });
      } else {
        window.Intercom("show");
        dispatch({ supportOpen: true });
      }
    }
  }, [loadingIntercom, supportOpen]);
  return { intercom_toggler, supportOpen, loadingIntercom };
};

export const useIntercomListener = (supportOpen) => {
  const [loadingIntercom] = useSelector(["loadingIntercom"], [false]);

  const { dispatch } = useDispatch();

  useEffect(() => {
    if (window.Intercom) {
      window.Intercom("onShow", () => dispatch({ supportOpen: true }));
      window.Intercom("onHide", () => dispatch({ supportOpen: false }));
    }
  }, [loadingIntercom, supportOpen]);
};

export const useLanguageToggle = (lang) => {
  const language_toggler = useCallback(() => {
    setLanguage(lang === "ar" ? "en" : "ar");
  }, [lang]);

  return { language_toggler };
};

export const useToggleReceiveSms = () => {
  const { dispatch } = useDispatch();
  const [user, smsLoading] = useSelector(
    ["user", "smsLoading"],
    [undefined, false]
  );

  const sms_toggler = useCallback(async () => {
    dispatch({ smsLoading: true });
    try {
      await http.post("/update-receive-sms-status", {
        status: !user?.receive_sms,
      });
      dispatch({ ...user, receive_sms: !user?.receive_sms }, "user");
    } catch (error) {
      handleError(error);
    }
    dispatch({ smsLoading: false });
  }, [user]);

  return { sms_toggler, smsLoading };
};
